// extracted by mini-css-extract-plugin
export default {"submit":"submit__AzH653","submitButton":"submitButton__jkyL1d"};